import { useCallback } from "react";

import * as Repository from "@/components/features/invoice-system-settings/model/repository";

import type * as FormModelType from "../type";

type Props = {
	inputModel: FormModelType.InvoiceSystemSettingsFormModel["InputModel"];
	onResetViewModel: () => void;
};

export const useUpdateInvoiceSystemSettings = ({ inputModel, onResetViewModel }: Props) => {
	const { onUpdateInvoiceSystemSettings: _onUpdateInvoiceSystemSettings } =
		Repository.Mutation.useInvoiceSystemSettingsMutation({ onResetViewModel });

	const onUpdateInvoiceSystemSettings = useCallback(
		async () =>
			await _onUpdateInvoiceSystemSettings({
				...inputModel,
				registrationCode: inputModel.registrationCode ? `T${inputModel.registrationCode}` : undefined, // InputModel への convert 時に除去した、接頭辞の T を付与する
			}),
		[inputModel, _onUpdateInvoiceSystemSettings],
	);

	return {
		onUpdateInvoiceSystemSettings,
	};
};
